module.exports = require('./helpers/bundle-url').getBundleURL('dj12v') + "aristoteles.0c0b5b4e.png";